// import BrowserLogger from 'alife-logger';
import BrowserLogger from '@arms/js-sdk';
import pkg from '../../package.json';

const ENV = {
  LOCAL: 'development', // 本地环境
  PRODUCTION: 'prod', // 生产环境
  DEVELOPMENT: 'dev', // 测试环境
  NEWTEST: 'newtest' // 新测试环境
};

// process.env.NODE_ENV - bl_config_environment 映射
const envMap = {
  [ENV.LOCAL]: 'local',
  [ENV.PRODUCTION]: 'prod',
  [ENV.DEVELOPMENT]: 'daily',
  [ENV.NEWTEST]: 'daily'
};

export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('userInfo') || '{}');
};
console.log(process.env.NODE_ENV, 'process_env');

const __bl = BrowserLogger.singleton({
  // TODO 只在生产环境开启
  // disabled: process.env.NODE_ENV !== ENV.PRODUCTION,
  disabled: process.env.NODE_ENV !== ENV.PRODUCTION && process.env.NODE_ENV !== ENV.DEVELOPMENT && process.env.NODE_ENV !== ENV.NEWTEST,
  // disabled: process.env.NODE_ENV !== ENV.PRODUCTION && process.env.NODE_ENV !== ENV.DEVELOPMENT && process.env.NODE_ENV !== ENV.LOCAL,

  pid: 'b2yyrpml12@7654c88b81d261a', // 项目唯一ID，由ARMS在创建站点时自动生成。
  uid: getUserInfo()?.workcode || 'unknown user',
  userName: getUserInfo()?.account_name || getUserInfo()?.name || 'unknown username',
  appType: 'web',
  imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
  sendResource: true,
  disableHook: true,
  behavior: true,
  enableSPA: true,
  parseHash() {
    const hashPath = window.location.hash?.replace(/^#/, '')?.replace(/\?.*$/, '');
    const path = window.location.href?.replace(/\?.*$/, '');
    return hashPath || path || '未知页面';
  },
  useFmp: true,
  release: pkg.version,
  environment: envMap[process.env.NODE_ENV || ENV.LOCAL] || 'local',
  ignore: {
    ignoreErrors: [
      function (str: string) {
        if (str && str.indexOf('ResizeObserver loop limit exceeded') >= 0) return true; // surely-vue依赖的resize-observer-polyfill包里报的，先忽略
        if (str && str.indexOf('ResizeObserver loop completed with undelivered notifications') >= 0) return true;
        if (str && str.indexOf('Script error.') >= 0) return true; // udc_voip_sdk 里面报的，先忽略
        return false; // 上报
      }
    ]
  },
  // 拦截不想上报的数据，返回null，undefined，0， false等，会取消本次上报
  beforeReport: (data) => {
    const reg = /^(\/[a-zA-Z])/;
    if (data.t === 'pv' && !reg.test(data?.page || '')) {
      return;
    }
    return data;
  }
});

export default __bl;
